import React from "react";
import styled from "styled-components";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { PeriodCompareChart } from "@myseotoolbox/ui-components";

import ChartPages from "./ChartPages";
import { seriesOf } from "./chartData";
import { Card } from "./Card";

const SMOOTHING = 3;
// The card's side padding, which the chart takes as its gutter so the line under its tabs reaches the card's edges.
const SIDE_PADDING = 18;
const PHONE_SIDE_PADDING = 16;

// PeriodCompareChart's colours, from its spec: it does not export them.
const BASE_LINE_COLOR = "#A3ABB8";
const PREVIOUS_COLOR = "#D9822B";
const CURRENT_COLOR = "#2A5BD7";
const MARKER_COLOR = "#3E4C63";

/**
 * The page's signals on `PeriodCompareChart`, each added page not hidden as another line on it, its legend, and
 * the list of the pages on it.
 */
export default function Chart({ page, metrics, metric, chart, selection, onChange, markers, added, hiddenIds, onToggleHidden }) {
    const drawn = metrics.find(({ key }) => key === metric);
    const phone = useMediaQuery("(max-width:600px)");
    return (
        <ChartCard>
            <PeriodCompareChart chart={chart} selection={selection} metrics={metrics} metric={metric} markers={markers}
                                series={seriesOf(added, hiddenIds)} smoothing={SMOOTHING} gutter={phone ? PHONE_SIDE_PADDING : SIDE_PADDING}
                                onChange={onChange} />
            <Below>
                <Key>
                    <span><KeyLine $color={BASE_LINE_COLOR} />{drawn.label}, {SMOOTHING}-day average</span>
                    <span><KeySwatch $color={PREVIOUS_COLOR} />Previous</span>
                    <span><KeySwatch $color={CURRENT_COLOR} />Current</span>
                    <span><KeyMarker />issue start — hover for what happened, click to compare around it</span>
                </Key>
                <ChartPages page={page} added={added} hiddenIds={hiddenIds} onToggleHidden={onToggleHidden} />
            </Below>
        </ChartCard>
    );
}

const ChartCard = styled(Card)`
    padding-left: 0;
    padding-right: 0;
    @media (max-width: 600px) {
        padding-left: 0;
        padding-right: 0;
    }
`;

const Below = styled.div`
    padding: 0 ${SIDE_PADDING}px;
    @media (max-width: 600px) { padding: 0 ${PHONE_SIDE_PADDING}px; }
`;

const Key = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px 14px;
    margin-top: 6px;
    font-size: 0.66rem;
    color: #94a3b8;
    span { display: inline-flex; align-items: center; gap: 5px; }
`;

const KeyLine = styled.span`
    width: 14px;
    border-top: 2px solid ${({ $color }) => $color};
`;

const KeySwatch = styled.span`
    width: 10px;
    height: 10px;
    border-radius: 3px;
    background: ${({ $color }) => $color};
`;

const KeyMarker = styled.span`
    width: 11px;
    height: 11px;
    box-sizing: border-box;
    border-radius: 50%;
    border: 1.5px solid rgba(62, 76, 99, 0.35);
    background: radial-gradient(circle, ${MARKER_COLOR} 0 1.5px, #fff 2px);
`;
